import React, { useEffect, useState } from "react"
import { MdCheckCircle, MdEmail, MdErrorOutline, MdOutlineMarkEmailRead, MdSecurity } from "react-icons/md"
import { useSearchParams } from "react-router-dom"
import Button from "../../components/Form/Button"
import Logo from "../../logo.svg"
import api from "../../services/api"
import styles from "./emailPreferences.module.css"

const contentByStatus = {
    loading: { icon: <MdEmail />, title: "Validando sua confirmação", message: "Estamos verificando se este link ainda pode ser utilizado." },
    invalid: { icon: <MdErrorOutline />, title: "Link indisponível", message: "Este link é inválido, expirou ou já foi utilizado." },
    ready: { icon: <MdOutlineMarkEmailRead />, title: "Voltar a receber comunicados", message: "Confirme seu novo consentimento para remover o endereço da lista de supressão." },
    complete: { icon: <MdCheckCircle />, title: "Preferência reativada", message: "Este endereço poderá receber novos comunicados de marketing." },
}

const Resubscribe = () => {
    const [searchParams] = useSearchParams()
    const token = searchParams.get("token") || ""
    const [status, setStatus] = useState("loading")
    const [details, setDetails] = useState(null)
    const [message, setMessage] = useState("")
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        let active = true
        const validate = async () => {
            if (!token) {
                setStatus("invalid")
                return
            }
            try {
                const response = await api.get("/email-preferences/resubscribe", { params: { token }, headers: { Accept: "application/json" } })
                if (!active) return
                if (!response.data?.data?.email_masked) throw new Error("Resposta inválida.")
                setDetails(response.data.data)
                setStatus(response.data.data.already_confirmed ? "complete" : "ready")
            } catch (err) {
                if (!active) return
                setMessage(err.response?.data?.message || "Este link é inválido, expirou ou já foi utilizado.")
                setStatus("invalid")
            }
        }
        validate()
        return () => { active = false }
    }, [token])

    const confirm = async () => {
        setSubmitting(true)
        setMessage("")
        try {
            const response = await api.post("/email-preferences/resubscribe/confirm", { token }, { headers: { Accept: "application/json" } })
            setDetails(response.data?.data || details)
            setMessage(response.data?.message || "Preferência reativada.")
            setStatus("complete")
        } catch (err) {
            setMessage(err.response?.data?.message || "Não foi possível confirmar a reativação.")
        } finally {
            setSubmitting(false)
        }
    }

    const content = contentByStatus[status]
    return (
        <main className={styles.page}>
            <section className={styles.card} aria-live="polite">
                <header className={styles.header}>
                    <img src={Logo} alt="Oktto" />
                    <span>Preferências de comunicação</span>
                </header>
                <div className={`${styles.statusIcon} ${status === "complete" ? styles.successIcon : status === "invalid" ? styles.errorIcon : ""}`}>{content.icon}</div>
                <h1>{content.title}</h1>
                <p className={styles.lead}>{message || content.message}</p>
                {status === "loading" && <div className={styles.loader} aria-label="Carregando" />}
                {["ready", "complete"].includes(status) && details?.email_masked && (
                    <div className={styles.recipient}>
                        <span>{status === "complete" ? "Endereço reativado" : "Endereço"}</span>
                        <strong>{details.email_masked}</strong>
                    </div>
                )}
                {status === "ready" && (
                    <>
                        <div className={styles.notice}>
                            <MdSecurity />
                            <div>
                                <strong>Confirmação explícita</strong>
                                <span>Ao confirmar, você registra um novo consentimento e volta a receber comunicados de marketing.</span>
                            </div>
                        </div>
                        <Button type="button" onClick={confirm} disabled={submitting}>
                            <MdOutlineMarkEmailRead /> {submitting ? "Confirmando..." : "Confirmar reativação"}
                        </Button>
                    </>
                )}
            </section>
        </main>
    )
}

export default Resubscribe
